export enum userGroupChangeEnum {
    PRIMARY = 1,
    SECONDARY = 2
}

export enum userStatusEnum {
    ATIVO = 1,
    INATIVO = 0
}